import { render, staticRenderFns } from "./QuestionsCoqun.vue?vue&type=template&id=8a1836f6&scoped=true&"
import script from "./QuestionsCoqun.vue?vue&type=script&lang=js&"
export * from "./QuestionsCoqun.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsCoqun.vue?vue&type=style&index=0&id=8a1836f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1836f6",
  null
  
)

export default component.exports